
'use client';

import SearchBar from "@packages/shared-components/skeleton/searchbar";
import { isWhatuni } from "@packages/lib/utlils/commonFunction";
import SearchBox from "./searchbox";
import { DataLayerGA4AttrType } from "@packages/lib/types/datalayerGA";

interface SearchboxwrapperProps {
   customGA?: DataLayerGA4AttrType,
   universalSearchPanel: any,
   parentPageName?: 'Home' | 'Clearing' | string
}

// const SearchBox = dynamic(() => import("./searchbox"), { ssr: false, loading: () => isWhatuni() ? <SearchBar parentPageName={'Home'} /> : <Pgssearchskeleton /> });

export default function Searchboxwrapper({ universalSearchPanel, customGA, parentPageName = 'Home' }: SearchboxwrapperProps) {

   if (isWhatuni() && !universalSearchPanel?.length)
      return <SearchBar parentPageName={parentPageName} />;

   return (
      <SearchBox universalSearchPanel={universalSearchPanel} parentPageName={parentPageName} customGA={customGA} />
   );
}
